// extracted by mini-css-extract-plugin
export var banner = "_as-0";
export var closeButton = "_as-2";
export var greenCheckmark = "_as-3";
export var hereLink = "_as-4";
export var titleIcon = "_as-1";